import { render, staticRenderFns } from "./QuestionnairePopup.vue?vue&type=template&id=2494e75a&scoped=true"
import script from "./QuestionnairePopup.vue?vue&type=script&lang=ts"
export * from "./QuestionnairePopup.vue?vue&type=script&lang=ts"
import style0 from "./QuestionnairePopup.vue?vue&type=style&index=0&id=2494e75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2494e75a",
  null
  
)

export default component.exports